import { render, staticRenderFns } from "./TabTerritory.vue?vue&type=template&id=f07a2fce"
import script from "./TabTerritory.vue?vue&type=script&lang=js"
export * from "./TabTerritory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports